import { useEffect } from "react";
import { PageHero } from "@/components/PageHero";
import { PortfolioGrid } from "@/components/PortfolioGrid";
import { FinalCta } from "@/components/FinalCta";
import { BUSINESS } from "@/data/site";

export default function Portfolio() {
  useEffect(() => { document.title = `Portfolio — ${BUSINESS.name}`; }, []);
  return (
    <>
      <PageHero
        overline="Portfolio"
        titleLines={["Websites that", "launch and rank."]}
        subtitle="A snapshot of the kinds of businesses we build for, across many industries. These are sample demo projects to show range and quality."
      />
      <PortfolioGrid heading={false} />
      <FinalCta />
    </>
  );
}
